import React from "react";
import {Link} from "react-router-dom";

class LinkButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {  };
  }
  render() { 
    let classes = `${this.props.classes} bg-orange border-0 rounded-md py-2 px-${this.props.padding} text-white font-t-bold uppercase`
    if (this.props.link) return (
      <Link to={this.props.link} className={classes} >{this.props.label}</Link>
    );
    return (
      <a href={this.props.href} className={classes} target={this.props.target} >{this.props.label}</a>
    )

  }
}
 
export default LinkButton;